import { render } from "./designPeople.vue?vue&type=template&id=19645730"
import script from "./designPeople.vue?vue&type=script&lang=js"
export * from "./designPeople.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__